import { makeStyles } from '@mui/styles';
import Error from '../../assets/images/error/error.png';

export const useStyles = makeStyles({
  iconPermission: {
    backgroundImage: `url(${Error})`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    height: '30vh',
    width: 'calc(81vw * 0.54 - 2%)',
    marginTop: 30
  },
  iconResultFound: {
    fontSize: 65,
    color: '#6C7882'
  },
  messageResultFound: {
    color: '#6C7882',
    fontSize: 'large',
    marginTop: 30
  }
});
